import React, { ComponentProps } from 'react';
import styled from 'styled-components';

// import React, { ComponentProps, ReactNode } from 'react';
// import styled, { css } from 'styled-components';
// import LinkIcon from '@material-ui/icons/OpenInNew';
import { commonLinkStyle } from './common.style';
import UnstyledLink from './UnstyledLink';

// const iconCss = css`
//   position: relative;
//   margin-right: 5px;
//   top: 4px;
// `;

// const Icon = styled.img`
//   ${iconCss}
//   color: var(--primary2);
// `;

// const LinkIconStyled = styled(LinkIcon)`
//   margin: -5px 5px;
// `;

// const IconElementWrap = styled.span`
//   ${iconCss}
//   & svg {
//     width: 15px;
//     height: 15px;

//     fill: var(--primary2);
//   }
// `;

const LinkEl = styled(UnstyledLink)`
  ${commonLinkStyle}
`;

type PropsLink = ComponentProps<typeof UnstyledLink> & {
  // icon?: string;
  // iconElement?: ReactNode;
  // externalLinkIcon?: boolean;
  underline?: boolean;
};

function Link({
  children,
  // icon,
  // iconElement,
  // externalLinkIcon,
  underline,
  color = 'light',
  href,
  target,
  ...rest
}: PropsLink) {
  return (
    <LinkEl
      color={color}
      href={href}
      $underline={underline}
      target={target || '_blank'}
      {...rest}
    >
      {/* {icon && <Icon src={icon} width={15} />} */}
      {/* {iconElement && <IconElementWrap>{iconElement}</IconElementWrap>} */}
      {children}
      {/* {externalLinkIcon && <LinkIconStyled fontSize="small" />} */}
    </LinkEl>
  );
}

export default Link;
